import { render } from "./IconLink.vue?vue&type=template&id=2dcd922c&ts=true"
import script from "./IconLink.vue?vue&type=script&lang=ts"
export * from "./IconLink.vue?vue&type=script&lang=ts"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__